export default [
  {
    path: 'notifications',
    name: 'notifications',
    component: () => import('@/views/Notification/Index.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      template: 'auth',
      name: 'notification',
    },
  },
];
